import { StatelessComponent } from 'react'
import Captcha from 'components/atoms/inputs/Captcha'
import { prepareFieldErrors } from 'helpers/formHelpers'
import { WrappedFieldProps, WrappedFieldInputProps } from 'redux-form'
import { State } from 'interfaces/state'
import { QAMarked } from 'interfaces/component'

type CaptchaWrappedProps = WrappedFieldProps<State> & QAMarked & {
  label: string
  image: string
}

const CaptchaWrapped: StatelessComponent<CaptchaWrappedProps> = (props) => {
  const { label, image, meta, qaMarker } = props
  const { active, touched, error } = meta
  const input = props.input as WrappedFieldInputProps

  return (
    <Captcha
      errored={ touched && !!error }
      errors={ prepareFieldErrors(error, touched) }
      active={ active }
      label={ label }
      image={ image }
      qaMarker={ qaMarker }
      { ...input }
    />
  )
}

export default CaptchaWrapped
